import script from "./Lifestyle.vue?vue&type=script&setup=true&lang=ts"
export * from "./Lifestyle.vue?vue&type=script&setup=true&lang=ts"

import "./Lifestyle.vue?vue&type=style&index=0&id=f260107e&lang=less&scoped=true"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f260107e"]])

export default __exports__